<template>
    <div>
      <a-drawer :title='title' :visible="visible" v-bind="drawerConfig" :body-style="{ paddingBottom: '80px' }" :closable="hasSelected" @close="onClose">
        <a-spin :spinning="spinning">
        <a-row class="acol">
            <a-col :span="6" style="text-align: right">
                字段名称：
            </a-col>
            <a-col :span="18">
                {{a_langset_field_name}}
            </a-col>
        </a-row>
            <div style="width: 73.4%;text-align: right">
                <span>全选：</span>   <a-checkbox :checked="a_langset_ids_cop.length==a_langset_ids.length"  @change="(e)=>{onChangeCheckbox(e,'all')}" defaultChecked   ></a-checkbox>
            </div>
        <a-form-model
                ref="dynamicValidateForm"
                :model="dynamicValidateForm"
                :label-col="labelCol"
                :wrapper-col="wrapperCol"

        >

            <a-form-model-item
                    v-for="(domain, index) in dynamicValidateForm.domains"
                    :key="domain.a_langset_id"
                    :label="domain.a_langset_name"
                    :prop="'domains.' + index + '.value'"
                   >
                <a-input :maxLength="200"
                        v-model="domain.content"
                        style="width: 60%; margin-right: 8px"
                />
                <a-checkbox @change="(e)=>{onChangeCheckbox(e,domain.a_langset_id)}" :checked="a_langset_ids.indexOf(domain.a_langset_id)>-1"  v-if="index!=0" ></a-checkbox>

            </a-form-model-item>

        </a-form-model>
        </a-spin>
        <div class="drawer-btn">
            <a-button type="primary" @click="field()"  :disabled="!hasSelected" :style="{ marginRight: '8px' }">
                翻译
            </a-button>
            <a-button type="primary" @click="submitForm('dynamicValidateForm')"  :disabled="!hasSelected" :style="{ marginRight: '8px' }">
                确定
            </a-button>
            <a-button  @click="onClose()"  :disabled="!hasSelected">
            取消
            </a-button>
        </div>
      </a-drawer>
    </div>
</template>

<script>
    import {submitForm,drawerConfig,validator} from "../../../../utils/utils"
    import API from "../api";
    export default {
        name: "fieldForm",
        props: ["visible","title","editId"],
        data() {
            return {
                indeterminate:false,
                hide:"submitKey",
                spinning: true,
                drawerConfig,
                a_langset_field_name:"",
                hasSelected:true,
                a_langset_ids:[],
                labelCol: {span:6},
                wrapperCol: {span:18},
                a_langset_ids_cop:[],
                dynamicValidateForm: {
                    domains: [],
                },
                layout: {
                    labelCol: { span: 4 },
                    wrapperCol: { span: 14 },
                },
            };
        },
        watch:{
            editId: function (a, b) {
                if (a != "") {
                    this.a_langset_ids=[]
                    this.spinning=true
                    API.field.GET_EDITLIST(a ).then(res => {
                        this.dynamicValidateForm.domains =res.data.data.info
                        this.a_langset_field_name=res.data.data.a_langset_field_name
                        this.dynamicValidateForm.domains.map((item,index)=>{
                            if(index!=0){
                                this.a_langset_ids.push(item.a_langset_id)
                            }
                            // this.a_langset_ids.push(item.a_langset_id)
                        })
                        this.a_langset_ids_cop=JSON.parse(JSON.stringify(this.a_langset_ids))
                        this.spinning=false
                    })
                }
            }
        },
        methods: {
            onChangeCheckbox(e,id){
                if(e.target.checked){
                    if(id=='all'){
                        this.indeterminate=true
                        this.a_langset_ids=this.a_langset_ids_cop
                    }else{
                        this.a_langset_ids=[...this.a_langset_ids,id]
                    }
                } else{
                    if(id=='all'){
                        this.indeterminate=false
                        this.a_langset_ids=[]
                    }else{
                        this.a_langset_ids.map((item,index)=>{
                            if(item==id)this.a_langset_ids.splice(index,1)
                        })
                    }
                }
            },
            onClose() {
                this.$emit("changVisible", false);
               this.dynamicValidateForm.domains=[]

                // this.$refs.ruleForm.resetFields();
            },
         field(){
             let i=0
             if(this.a_langset_ids.length>0){
                 this.spinning=true
                 this.hasSelected=false
                 let hide = this.$message.loading({content:'正在提交', duration: 0,key:this.hide} )
                 this.promiseRun(i)
             }else{
                 this.$message.error("请选择翻译语言",1.5)
             }
            },
            promiseRun(i){
                let _that=this
                this.submitField(this.a_langset_ids[i],i).then(res=>{
                    if(res!="false"){
                        _that.submitField(this.a_langset_ids[res],res).then(resa=>{
                            if(resa!="false"){
                                _that.promiseRun(resa)
                            }else{
                                _that.$message.success({content: "翻译完成", key:this.hide, duration: 2})
                                _that.spinning = false
                                _that.hasSelected=true
                            }
                        })
                    }  else{
                        _that.$message.success({content:  "翻译完成", key:this.hide, duration: 2})
                        _that.spinning = false
                        _that.hasSelected=true
                    }
                })
            },
          submitField(id, i) {
            let _that = this
            return new Promise((resolve, reject) => {
              console.log("--**--", i, ":::", _that.a_langset_ids.length)
              if (i < _that.a_langset_ids.length) {
                API.field.FIELD({
                  a_langset_id: id,
                  content: this.dynamicValidateForm.domains[0].content
                }).then(res => {
                  if (res.data.code === 200) {
                    this.$message.success({content: res.data.msg, duration: 1})
                    let data = res.data.data.content
                    this.dynamicValidateForm.domains.map((item, index) => {
                      if (id == item.a_langset_id) {
                        item.content = data
                      }
                    })
                    i++
                    resolve(i)
                  } else {
                    this.$message.destroy()
                    // i++
                    // resolve(i)
                  }
                })
              } else {
                resolve("false")
              }
            })
          },
            submitForm(formName) {
                let _this=this
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        _this.dynamicValidateForm.domains.map((item,index)=>{
                            delete item["a_langset_name"]
                        })
                        submitForm(API.field.SUBMIT_EDITLIST, _this.dynamicValidateForm.domains).then(res => {
                                            if (res == true) {
                                                this.onClose()
                                            } else {
                                                // res.map((item, index) => {
                                                //     this.formErr[item.field] = item.msg
                                                // })
                                            }
                                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>
.acol{font-weight: bold;margin-bottom: 15px}
</style>
